import React from "react";
import { Button, Modal, Alert, ModalBody } from "reactstrap";

const SubmissionPopup = (props) => {
  return (
    <Modal isOpen={props.modal} toggle={props.toggle}>
      <ModalBody>
        <Alert
          color={props.color}
          style={{
            width: "100%",
            textAlign: "center",
          }}
        >
          <h6>{props.message}</h6>
        </Alert>
        <div style={{ float: "right" }}>
          <Button color="secondary" onClick={props.toggle}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SubmissionPopup;
